const isProd = process.env.NODE_ENV === 'production'

const Datadog = {
  install(Vue, datadogRum) {
    Vue.prototype.$initDatadog = function() {
      if(isProd) {
        datadogRum.init({
          applicationId: 'b3ef5044-e656-47bf-b2f3-0f06684c6da6',
          clientToken: 'pub498390b5a7e6a907444e97769187bab7',
          site: 'datadoghq.com',
          service: 'app-ami',
          env: 'prod',
          sessionSampleRate: 100,
          sessionReplaySampleRate: 100,
          trackUserInteractions: true,
          trackResources: true,
          trackLongTasks: true,
          defaultPrivacyLevel: 'mask-user-input'
        })
      }
    }

    Vue.prototype.$setDatadogUser = function(id, nome, email) {
      datadogRum.setUser({
        id: id,
        name: nome,
        email: email
      })
    }
    
    Vue.prototype.$getDatadogUser = function() {
      return 
    }

    Vue.prototype.$logoutDatadogUser = function() {
      datadogRum.clearUser()
    }
  }
}

export default Datadog
